import ChartNivAnafylaxieEnAngioOedeem from "../../../../src/client/niv_acuteboekje/json/anafylaxie-en-angio-oedeem.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivAnafylaxieEnAngioOedeem,
  ChartNivSimple,
  ButtonSchematic,
  React
};